<template>
  <div id="mapWindow" ref="mapWindow" class="map-block">
    <loading :active.sync="inModulation" :is-full-page="false"></loading>
    <b-list-group style="position: fixed; top: 0px; left: 0px; display: none; z-index: 999999" ref="instatllationMenu">
      <b-list-group-item class="p-2 d-flex justify-content-between align-items-center"
        >Название
        <b-btn
          sise="sm"
          @click="
            clearAll();
            $refs.instatllationMenu.style.display = 'none';
          "
          variant="outline-danger"
          class="p-0 m-0"
          ><i class="fa fa-close p-0 m-0"></i></b-btn
      ></b-list-group-item>
      <b-list-group-item href="#" @click="$refs.installationToMap.show()">Изменить объект</b-list-group-item>
      <b-list-group-item href="#" @click="$refs.installationToMap.show()">Присоеденить трубопровод</b-list-group-item>
      <b-list-group-item href="#" @click="$refs.installationToMap.show()"
        >Присоеденить гибкое соединение</b-list-group-item
      >
      <b-list-group-item href="#" @click="$refs.installationToMap.show()">Изменить точку</b-list-group-item>
      <b-list-group-item href="#">Удалить точку</b-list-group-item>
    </b-list-group>
    <!-- Панель с иконками, слои -->
    <layers-menu
      :layers="layers"
      :projectStatus="project.status"
      @onDropdownChange="handleDropdownChange"
      @onLayerButtonClick="handleLayerButtonClick"
    />

    <!-- Панель риска -->

    <risk-panel
      @onFilterButtonClick="handleFilterButtonClick"
      :analyse="analyse"
      @onRiskSelectChange="handleRiskSelectChange"
      :selectValue="analyse.factor"
    />

    <!-- Регулировка размера иконок и прозрачности -->
    <range-inputs-panel
      :opacity="opacity"
      :project="project"
      @onIconScaleChange="handleIconScaleChange"
      @onOpacityChange="handleOpacityChange"
    />

    <!-- Панель с данными по риску -->
    <risk-info
      v-if="!analyse.factor || analyse.factor == 0 || tourStep == 16"
      :oldData="oldData"
      :maxIndRisk="maxIndRisk"
      :legalIndRisk="$parent.legalIndRisk"
      :toNormal="$parent.toNormal"
      :maxIndRiskRes="maxIndRiskRes"
      :legalResIndRisk="$parent.legalResIndRisk"
      :legalResSocRisk="$parent.legalResSocRisk"
      :maxSocialRisk="maxSocialRisk"
    />

    <div
      v-if="substrate"
      class="map"
      ref="map"
      style="border-radius: 5px"
      @dragover.stop="allowDrop($event)"
      @drop.prevent="drop($event)"
      @mouseover="toggleHtmlClass('addClass', 'disScroll')"
      @mouseleave="toggleHtmlClass('removeClass', 'disScroll')"
      @mousemove="cursor = getScaledPointerPosition()"
      @contextmenu.prevent
    >
      <v-stage
        :config="{
          ...configKonva,
          ...{
            dragBoundFunc(pos) {
              return {
                x: pos.x,
                y: pos.y,
              };
            },
          },
        }"
        ref="mapLayer"
        v-on:wheel="zoom"
        @click="mapAction()"
      >
        <v-layer :config="{ listening: false }">
          <url-image
            v-if="substrate && substrateUrl && layers.substrate == 1"
            ref="sub"
            :imageUrl="substrateUrl"
          ></url-image>
          <url-image
            v-if="zonesImage && layers.zones == 1"
            :config="{ opacity: 1 - Number(opacity), width: substrate.height, height: substrate.width }"
            :width="substrate.width"
            :imageUrl="zonesImage"
          ></url-image>
        </v-layer>

        <v-layer ref="objectsLayer">
          <v-shape
            :key="`dikings-${index}`"
            v-for="(diking, index) in dikingsWithoutExclude"
            :config="{
              sceneFunc: shapeSceneFunc(diking),
              perfectDrawEnabled: false,
              fill: zones ? 0 : diking.focused ? '#0064ff' : '#00D2FF',
              stroke: 'black',
              strokeWidth: 4 * iconsScale,
              opacity: 0.5,
            }"
          >
          </v-shape>
          <span :key="`d-${d_index}`" v-for="(diking, d_index) in dikingsWithoutExclude">
            <v-circle
              :key="`anchor-${index}`"
              v-for="(anchor, index) in anchorsWithoutDeleted(diking.dots)"
              @mousedown="showDikingNodeWindow(diking, index)"
              @dragEnd="dikingNewPos(diking)"
              :config="{
                x: parseInt(anchor.x),
                y: parseInt(anchor.y),
                radius: 5 * iconsScale,
                stroke: '#666',
                fill: '#ddd',
                strokeWidth: 4 * iconsScale,
                draggable: true,
                dragBoundFunc(pos) {
                  dikings[d_index].dots[index].x = getScaledPointerPosition().x;
                  dikings[d_index].dots[index].y = getScaledPointerPosition().y;
                  return {
                    x: pos.x,
                    y: pos.y,
                  };
                },
              }"
              @mouseover="anchorOver(index)"
              @mouseout="anchorOut(index)"
            >
            </v-circle>
          </span>

          <v-shape
            v-if="newDiking && !newDiking.diking_id"
            :config="{
              sceneFunc: shapeSceneFuncV2(newDiking),
              perfectDrawEnabled: false,
              fill: 'red',
              stroke: 'black',
              strokeWidth: 4 * iconsScale,
              opacity: 0.5,
            }"
          >
          </v-shape>

          <v-circle
            v-if="newDiking && newDiking.dots && newDiking.dots.length == 1 && !newDiking.diking_id"
            :config="{
              x: newDiking.dots[0].x,
              y: newDiking.dots[0].y,
              radius: 5,
              stroke: '#666',
              fill: '#666',
              strokeWidth: 4,
            }"
          >
          </v-circle>

          <v-shape
            :key="`solid-${index}`"
            v-for="(solid, index) in solidWithoutExclude"
            :config="{
              sceneFunc: shapeSceneFunc(solid),
              perfectDrawEnabled: false,
              fill: 'red',
              stroke: 'black',
              strokeWidth: 4 * iconsScale,
              opacity: 0.5,
            }"
          >
          </v-shape>
          <span :key="`s-${d_index}`" v-for="(solid, d_index) in solidWithoutExclude">
            <v-circle
              :key="`an-${index}`"
              v-for="(anchor, index) in anchorsWithoutDeleted(solid.dots)"
              @mousedown="showSolidNodeWindow(solid, index)"
              @dragEnd="solidNewPos(solid)"
              :config="{
                x: parseInt(anchor.x),
                y: parseInt(anchor.y),
                radius: 5 * iconsScale,
                stroke: '#666',
                fill: '#ddd',
                strokeWidth: 4 * iconsScale,
                draggable: true,
                dragBoundFunc(pos) {
                  solids[d_index].dots[index].x = getScaledPointerPosition().x;
                  solids[d_index].dots[index].y = getScaledPointerPosition().y;
                  return {
                    x: pos.x,
                    y: pos.y,
                  };
                },
              }"
              @mouseover="anchorOver(index)"
              @mouseout="anchorOut(index)"
            >
            </v-circle>
          </span>

          <v-shape
            v-if="newSolid && !newSolid.id"
            :config="{
              sceneFunc: shapeSceneFuncV2(newSolid),
              perfectDrawEnabled: false,
              fill: 'red',
              stroke: 'black',
              strokeWidth: 4 * iconsScale,
              opacity: 0.5,
            }"
          >
          </v-shape>

          <v-circle
            v-if="newSolid && newSolid.dots && newSolid.dots.length == 1 && !newSolid.id"
            :config="{
              x: newSolid.dots[0].x,
              y: newSolid.dots[0].y,
              radius: 5,
              stroke: '#666',
              fill: '#666',
              strokeWidth: 4,
            }"
          >
          </v-circle>

          <v-line
            v-if="newFirewall"
            :config="{
              sceneFunc: shapeBuildingSceneFunc(newFirewall),
              perfectDrawEnabled: false,
              stroke: 'black',
              strokeWidth: 4 * iconsScale,
              opacity: 0.5,
            }"
          >
          </v-line>

          <v-circle
            v-if="newFirewall && newFirewall.dots && newFirewall.dots.length == 1"
            :config="{
              x: newFirewall.dots[0].x,
              y: newFirewall.dots[0].y,
              radius: 5 * iconsScale,
              stroke: '#666',
              fill: '#666',
              strokeWidth: 4,
            }"
          >
          </v-circle>

          <v-line
            v-if="newPipeline"
            :config="{
              sceneFunc: shapeBuildingSceneFunc(newPipeline),
              perfectDrawEnabled: false,
              stroke: 'black',
              strokeWidth: 4 * iconsScale,
              opacity: 0.5,
            }"
          >
          </v-line>

          <v-circle
            v-if="newPipeline && newPipeline.dots && newPipeline.dots.length == 1"
            :config="{
              x: newPipeline.dots[0].x,
              y: newPipeline.dots[0].y,
              radius: 5 * iconsScale,
              stroke: '#666',
              fill: '#666',
              strokeWidth: 4,
            }"
          >
          </v-circle>
          <v-line
            v-if="newPipeline"
            :config="{
              sceneFunc: shapeBuildingSceneFunc(newPipeline),
              perfectDrawEnabled: false,
              stroke: 'black',
              strokeWidth: 4 * iconsScale,
              opacity: 0.5,
            }"
          >
          </v-line>

          <v-circle
            v-if="newPipeline && newPipeline.dots && newPipeline.dots.length == 1"
            :config="{
              x: newPipeline.dots[0].x,
              y: newPipeline.dots[0].y,
              radius: 5 * iconsScale,
              stroke: '#666',
              fill: '#666',
              strokeWidth: 4,
            }"
          >
          </v-circle>

          <v-line
            v-if="newRoadDots"
            :config="{
              sceneFunc: shapeRoadSceneFunc(newRoadDots),
              perfectDrawEnabled: false,
              stroke: 'black',
              strokeWidth: 4 * iconsScale,
              opacity: 0.5,
              dash: [20, 10],
            }"
          >
          </v-line>

          <v-circle
            v-if="newRoadDots && newRoadDots.length == 1"
            :config="{
              x: newRoadDots[0].x,
              y: newRoadDots[0].y,
              radius: 5 * iconsScale,
              stroke: '#666',
              fill: '#666',
              strokeWidth: 4,
            }"
          >
          </v-circle>

          <span v-for="(installation, index) in installationWithoutExclude" :key="installation.id">
            <span
              v-for="(object, o_index) in installationObjectsWithoutexclude(installation.mapObjects)"
              :key="object.id"
            >
              <template v-if="layers.pipelines == 1">
                <pipeline
                  v-for="(pipeline, personIndex) in object.pipelines"
                  @pipelineFocus="pipelineFocus(index, o_index, personIndex)"
                  @showPipelineNodeWindow="showPipelineNodeWindow($event)"
                  @pipelineNewPos="pipelineNewPos($event)"
                  :mapLayer="$refs.mapLayer"
                  :key="pipeline.id"
                  :pipeline="pipeline"
                  :dots="pipeline.dots"
                  :startX="object.pipeStartLat ? object.pipeStartLat : parseInt(object.lat)"
                  :startY="object.pipeStartLng ? object.pipeStartLng : parseInt(object.lng)"
                  :iconsScale="iconsScale"
                  :color="installation.color"
                />
              </template>
            </span>
            <v-group
              v-for="(object, o_index) in installationObjectsWithoutexclude(installation.mapObjects)"
              :key="o_index"
              @dragend="objectNewPos(object.id, index, o_index, 'installation')"
              :config="{
                x: parseFloat(object.lat),
                y: parseFloat(object.lng),
                draggable: true,
                dragBoundFunc(pos) {
                  object.pipeStartLat = getScaledPointerPosition().x;
                  object.pipeStartLng = getScaledPointerPosition().y;

                  return {
                    x: pos.x,
                    y: pos.y,
                  };
                },
              }"
            >
              <url-image
                v-if="1 != 1"
                :config="{
                  src: $parent.getInstallationImage(installation.obj_type),
                  width: 96,
                  height: 96,
                  offsetX: 48,
                  offsetY: 48,
                }"
              ></url-image>
              <v-circle
                :config="{
                  radius: object.focused ? 25 * iconsScale : 16 * iconsScale,
                  fill: installation.color,
                  stroke: 'black',
                  strokeWidth: 0,
                  stroke: 'black',
                  strokeWidth: 3 * iconsScale,
                }"
              ></v-circle>
              <v-label>
                <v-text
                  :config="{
                    text: object.icon_text,
                    fontSize: 20 * iconsScale,
                    lineHeight: 1.2,
                    padding: -9 * iconsScale,
                    ellipsis: true,
                    fill: 'white',
                  }"
                ></v-text>
              </v-label>
            </v-group>
          </span>
          <span v-if="layers.pipelines == 1">
            <pipeline
              v-for="(pipeline, personIndex) in pipelines"
              @pipelineFocus="pipelineFocus(index, o_index, personIndex)"
              @showPipelineNodeWindow="showPipelineNodeWindow($event)"
              @pipelineNewPos="pipelineNewPos($event)"
              :mapLayer="$refs.mapLayer"
              :key="pipeline.id"
              :pipeline="pipeline"
              :dots="pipeline.dots"
              :startX="pipeline.dots[0].x"
              :startY="pipeline.dots[0].y"
              :iconsScale="iconsScale"
              :color="pipeline.color"
            ></pipeline>
          </span>
          <span v-if="layers.people == 1">
            <span :key="`people-${index}`" v-for="(person, index) in people">
              <v-group
                v-for="(object, o_index) in person.mapObjects"
                :key="`lat-${o_index}`"
                :config="{
                  draggable: true,
                  x: object.lat,
                  y: object.lng,
                  dragBoundFunc(pos) {
                    object.lat = getScaledPointerPosition().x;
                    object.lng = getScaledPointerPosition().y;
                    return {
                      x: pos.x,
                      y: pos.y,
                    };
                  },
                }"
                @dragend="objectNewPos(object.id, index, o_index, 'people')"
              >
                <url-image
                  v-if="1 != 1"
                  :config="{
                    src: require('../../assets/icons/engineer123.png'),
                    width: 96,
                    height: 96,
                    offsetX: 48,
                    offsetY: 80,
                  }"
                ></url-image>
                <v-regular-polygon
                  :config="{
                    sides: 3,
                    radius: object.focused ? 30 * iconsScale : 20 * iconsScale,
                    fill: person.color,
                    stroke: 'black',
                    strokeWidth: 3 * iconsScale,
                  }"
                >
                </v-regular-polygon>
                <v-label>
                  <v-text
                    :config="{
                      text: object.icon_text,
                      fontSize: 20 * iconsScale,
                      lineHeight: 1,
                      padding: -7 * iconsScale,
                      ellipsis: true,
                      fill: 'white',
                    }"
                  ></v-text>
                </v-label>
              </v-group>
            </span>
          </span>

          <template v-for="building in filteredResidentialTypeOne">
            <v-line
              :key="`building-${building.id}`"
              :config="{
                sceneFunc: shapeBuildingSceneFunc(building),
                perfectDrawEnabled: false,
                stroke: 'white',
                strokeWidth: 4 * iconsScale + 20,
                opacity: 0.8,
              }"
            >
            </v-line>
            <v-line
              :key="`bu-${building.id}`"
              :config="{
                sceneFunc: shapeBuildingSceneFunc(building),
                perfectDrawEnabled: false,
                stroke: building.color,
                strokeWidth: 4 * iconsScale,
                opacity: 0.5,
                dash: [20, 10],
              }"
            >
            </v-line>
            <v-regular-polygon
              v-for="(dot, i) in building.dots"
              :key="`b1-${dot.x + i}`"
              :config="{
                sides: 5,
                radius: building.focused ? 30 * iconsScale : 20 * iconsScale,
                fill: building.color,
                stroke: 'black',
                strokeWidth: 3 * iconsScale,
                x: parseInt(dot.x),
                y: parseInt(dot.y),
              }"
            >
            </v-regular-polygon>
            <v-label :key="`b2-${dot.y + i}`" v-for="(dot, i) in building.dots">
              <v-text
                :config="{
                  text: building.icon_text,
                  fontSize: 20 * iconsScale,
                  lineHeight: 1,
                  padding: -7 * iconsScale,
                  ellipsis: true,
                  fill: 'white',
                  x: parseInt(dot.x),
                  y: parseInt(dot.y),
                }"
              ></v-text>
            </v-label>
          </template>
          <template
            v-for="building in residential"
            v-if="parseInt(building.exclude) != 1 && building.type == 4 && layers.buildings == 1"
          >
            <v-line
              :config="{
                sceneFunc: function (context, shape) {
                  context.beginPath();

                  for (var i in building.dots) {
                    context.lineTo(building.dots[i].x, building.dots[i].y);
                  }
                  // special Konva.js method
                  context.fillStrokeShape(shape);
                },
                perfectDrawEnabled: false,
                stroke: 'white',
                strokeWidth: 4 * iconsScale + 5,
                opacity: 0.8,
              }"
            >
            </v-line>
            <v-line
              :config="{
                sceneFunc: function (context, shape) {
                  context.beginPath();

                  for (var i in building.dots) {
                    context.lineTo(building.dots[i].x, building.dots[i].y);
                  }
                  // special Konva.js method
                  context.fillStrokeShape(shape);
                },
                perfectDrawEnabled: false,
                stroke: building.color,
                strokeWidth: 4 * iconsScale + 5,
                opacity: 0.5,
                dash: [20, 20],
              }"
            >
            </v-line>
            <v-regular-polygon
              v-for="dot in building.dots"
              :config="{
                sides: 5,
                radius: building.focused ? 30 * iconsScale : 20 * iconsScale,
                fill: building.color,
                stroke: 'black',
                strokeWidth: 3 * iconsScale,
                x: parseInt(dot.x),
                y: parseInt(dot.y),
              }"
            >
            </v-regular-polygon>
            <v-label v-for="dot in building.dots">
              <v-text
                :config="{
                  text: building.icon_text,
                  fontSize: 20 * iconsScale,
                  lineHeight: 1,
                  padding: -7 * iconsScale,
                  ellipsis: true,
                  fill: 'white',
                  x: parseInt(dot.x),
                  y: parseInt(dot.y),
                }"
              ></v-text>
            </v-label>
          </template>
          <template
            v-for="(building, index) in residential"
            v-if="
              parseInt(building.exclude) != 1 && (building.type == 1 || building.type == 2) && layers.buildings == 1
            "
          >
            <v-group
              :config="{ draggable: true, x: parseInt(building.lat), y: parseInt(building.lng) }"
              @dragend="socialNewPos(building.id, index, 'residential')"
            >
              <url-image
                v-if="1 != 1"
                :config="{
                  src: require('../../assets/icons/hotel.png'),
                  width: 96,
                  height: 96,
                  offsetX: 48,
                  offsetY: 48,
                }"
              ></url-image>
              <v-regular-polygon
                :config="{
                  sides: 5,
                  radius: building.focused ? 30 * iconsScale : 20 * iconsScale,
                  fill: building.color,
                  stroke: 'black',
                  strokeWidth: 3 * iconsScale,
                }"
              >
              </v-regular-polygon>
              <v-label>
                <v-text
                  :config="{
                    text: building.icon_text,
                    fontSize: 20 * iconsScale,
                    lineHeight: 1,
                    padding: -7 * iconsScale,
                    ellipsis: true,
                    fill: 'white',
                  }"
                />
              </v-label>
            </v-group>
          </template>

          <template v-for="(firewall, i) in firewalls" v-if="parseInt(firewall.exclude) != 1 && layers.firewalls == 1">
            <v-line
              :key="`firewall-${i}`"
              :config="{
                sceneFunc: function (context, shape) {
                  context.beginPath();

                  for (var i in firewall.dots) {
                    context.lineTo(firewall.dots[i].x, firewall.dots[i].y);
                  }
                  // special Konva.js method
                  context.fillStrokeShape(shape);
                },
                perfectDrawEnabled: false,
                stroke: 'white',
                strokeWidth: 4 * iconsScale + 5,
                opacity: 0.8,
              }"
            >
            </v-line>
            <v-line
              :config="{
                sceneFunc: function (context, shape) {
                  context.beginPath();

                  for (var i in firewall.dots) {
                    context.lineTo(firewall.dots[i].x, firewall.dots[i].y);
                  }
                  // special Konva.js method
                  context.fillStrokeShape(shape);
                },
                perfectDrawEnabled: false,
                stroke: 'red',
                strokeWidth: 4 * iconsScale + 5,
                opacity: 0.5,
                dash: [10, 2],
              }"
            >
            </v-line>
          </template>
          <template
            v-for="(firewall, d_index) in firewalls"
            v-if="parseInt(firewall.exclude) != 1 && layers.firewalls == 1"
          >
            <v-circle
              v-for="(anchor, index) in firewall.dots"
              v-if="!anchor.deleted"
              @dragEnd="firewallNewPos(firewall)"
              :config="{
                x: parseInt(anchor.x),
                y: parseInt(anchor.y),
                radius: 5 * iconsScale,
                stroke: '#666',
                fill: '#ddd',
                strokeWidth: 4 * iconsScale,
                draggable: true,
                dragBoundFunc(pos) {
                  firewalls[d_index].dots[index].x = getScaledPointerPosition().x;
                  firewalls[d_index].dots[index].y = getScaledPointerPosition().y;
                  return {
                    x: pos.x,
                    y: pos.y,
                  };
                },
              }"
              @mouseover="anchorOver(index)"
              @mouseout="anchorOut(index)"
            >
            </v-circle>
          </template>

          <v-line
            v-if="scale && scale[0]"
            :config="{
              points: [parseInt(scale[0].x), parseInt(scale[0].y), cursor.x, cursor.y],
              stroke: 'black',
              strokeWidth: 4 * iconsScale,
            }"
          >
          </v-line>
          <v-label
            v-if="scale && scale[0] && action == 'ruler'"
            :config="{ x: cursor.x, y: cursor.y, opacity: 0.75, fill: 'white' }"
            ><v-tag
              :config="{
                fill: 'black',
                pointerDirection: 'down',
                pointerWidth: 10 * iconsScale,
                pointerHeight: 10 * iconsScale,
                lineJoin: 'round',
                shadowColor: 'black',
                shadowBlur: 10 * iconsScale,
                shadowOffset: 10 * iconsScale,
                shadowOpacity: 0.5,
              }"
            />
            <v-text
              :config="{
                text: (
                  Math.sqrt(
                    Math.pow(parseInt(this.scale[0].x) - this.cursor.x, 2) +
                      Math.pow(parseInt(this.scale[0].y) - this.cursor.y, 2)
                  ) / substrate.k
                ).toFixed(2),
                fontFamily: 'Calibri',
                fontSize: 18 * iconsScale,
                padding: 5 * iconsScale,
                fill: 'white',
              }"
            />
          </v-label>
        </v-layer>
        <v-layer>
          <v-label
            v-if="!oldData && currentRisk && currentRisk.risk"
            :config="{ x: currentRisk.lat, y: currentRisk.lng, opacity: 0.75, fill: 'white' }"
          >
            <v-tag
              :config="{
                fill: 'black',
                pointerDirection: 'down',
                pointerWidth: 10 * iconsScale,
                pointerHeight: 10 * iconsScale,
                lineJoin: 'round',
                shadowColor: 'black',
                shadowBlur: 10 * iconsScale,
                shadowOffset: 10 * iconsScale,
                shadowOpacity: 0.5,
              }"
            ></v-tag
            ><v-text
              :config="{
                text: toNormal(currentRisk.risk),
                fontFamily: 'Calibri',
                fontSize: 18 * iconsScale,
                padding: 5 * iconsScale,
                fill: 'white',
              }"
            ></v-text>
          </v-label>

          <nodeMenu
            v-if="pipelineNode && pipelineNode.show"
            :pipeline="true"
            :object="pipelineNode"
            @save="pipelineNewPos($event)"
            @changeCursor="changeCursor"
          ></nodeMenu>
          <nodeMenu
            v-if="dikingNode && dikingNode.show"
            :object="dikingNode"
            @save="dikingNewPos($event)"
            @changeCursor="changeCursor"
          ></nodeMenu>
          <nodeMenu
            v-if="solidNode && solidNode.show"
            :object="solidNode"
            @save="solidNewPos($event)"
            @changeCursor="changeCursor"
          ></nodeMenu>
        </v-layer>
        <!-- Верхний слой с кнопками для сохранения объектов -->
        <v-layer :config="{ listening: true }">
          <v-label
            v-if="newPipeline && newPipeline.dots && newPipeline.dots.length > 1"
            @click="pipelineFinish()"
            :config="{
              x: newPipeline.dots[newPipeline.dots.length - 1].x,
              y: newPipeline.dots[newPipeline.dots.length - 1].y,
              opacity: 0.75,
              fill: 'white',
            }"
            ><v-tag
              :config="{
                fill: 'black',
                pointerDirection: 'down',
                pointerWidth: 10 * iconsScale,
                pointerHeight: 10 * iconsScale,
                lineJoin: 'round',
                shadowColor: 'black',
                shadowBlur: 10 * iconsScale,
                shadowOffset: 10 * iconsScale,
                shadowOpacity: 0.5,
              }"
            />
            <v-text
              :config="{
                text: 'Сохранить',
                fontFamily: 'Calibri',
                fontSize: 18 * iconsScale,
                padding: 5 * iconsScale,
                fill: 'white',
              }"
            />
          </v-label>

          <v-label
            v-if="newRoadDots && newRoadDots.length > 1"
            @click="socialRoadAdd()"
            :config="{
              x: newRoadDots[newRoadDots.length - 1].x,
              y: newRoadDots[newRoadDots.length - 1].y,
              opacity: 0.75,
              fill: 'white',
            }"
            ><v-tag
              :config="{
                fill: 'black',
                pointerDirection: 'down',
                pointerWidth: 10 * iconsScale,
                pointerHeight: 10 * iconsScale,
                lineJoin: 'round',
                shadowColor: 'black',
                shadowBlur: 10 * iconsScale,
                shadowOffset: 10 * iconsScale,
                shadowOpacity: 0.5,
              }"
            /><v-text
              :config="{
                text: 'Сохранить',
                fontFamily: 'Calibri',
                fontSize: 18 * iconsScale,
                padding: 5 * iconsScale,
                fill: 'white',
              }"
            />
          </v-label>

          <v-label
            v-if="newPipeline && newPipeline.dots && newPipeline.dots.length > 1"
            @click="pipelineFinish()"
            :config="{
              x: newPipeline.dots[newPipeline.dots.length - 1].x,
              y: newPipeline.dots[newPipeline.dots.length - 1].y,
              opacity: 0.75,
              fill: 'white',
            }"
            ><v-tag
              :config="{
                fill: 'black',
                pointerDirection: 'down',
                pointerWidth: 10 * iconsScale,
                pointerHeight: 10 * iconsScale,
                lineJoin: 'round',
                shadowColor: 'black',
                shadowBlur: 10 * iconsScale,
                shadowOffset: 10 * iconsScale,
                shadowOpacity: 0.5,
              }"
            />
            <v-text
              :config="{
                text: 'Сохранить',
                fontFamily: 'Calibri',
                fontSize: 18 * iconsScale,
                padding: 5 * iconsScale,
                fill: 'white',
              }"
            />
          </v-label>

          <v-label
            v-if="newDiking && newDiking.dots && newDiking.dots.length > 2 && !newDiking.diking_id"
            @click="dikingWindow()"
            :config="{
              x: newDiking.dots[newDiking.dots.length - 1].x,
              y: newDiking.dots[newDiking.dots.length - 1].y,
              opacity: 0.75,
              fill: 'white',
            }"
            ><v-tag :config="{ fill: 'black', shadowOpacity: 0.5 }" />
            <v-text
              :config="{
                text: 'Сохранить',
                fontFamily: 'Calibri',
                fontSize: 18 * iconsScale,
                padding: 5 * iconsScale,
                fill: 'white',
              }"
          /></v-label>

          <v-label
            v-if="newSolid && newSolid.dots && newSolid.dots.length > 2 && !newSolid.id"
            @click="solidWindow()"
            :config="{
              x: newSolid.dots[newSolid.dots.length - 1].x,
              y: newSolid.dots[newSolid.dots.length - 1].y,
              opacity: 0.75,
              fill: 'white',
            }"
          >
            <v-tag
              :config="{
                fill: 'black',
                pointerDirection: 'down',
                pointerWidth: 10 * iconsScale,
                pointerHeight: 10 * iconsScale,
                lineJoin: 'round',
                shadowColor: 'black',
                shadowBlur: 10 * iconsScale,
                shadowOffset: 10 * iconsScale,
                shadowOpacity: 0.5,
              }" /><v-text
              :config="{
                text: 'Сохранить',
                fontFamily: 'Calibri',
                fontSize: 18 * iconsScale,
                padding: 5 * iconsScale,
                fill: 'white',
              }"
          /></v-label>

          <v-label
            v-if="newFirewall && newFirewall.dots && newFirewall.dots.length > 1"
            @click="firewallWindow()"
            :config="{
              x: newFirewall.dots[newFirewall.dots.length - 1].x,
              y: newFirewall.dots[newFirewall.dots.length - 1].y,
              opacity: 0.75,
              fill: 'white',
            }"
            ><v-tag
              :config="{
                fill: 'black',
                pointerDirection: 'down',
                pointerWidth: 10 * iconsScale,
                pointerHeight: 10 * iconsScale,
                lineJoin: 'round',
                shadowColor: 'black',
                shadowBlur: 10 * iconsScale,
                shadowOffset: 10 * iconsScale,
                shadowOpacity: 0.5,
              }"
            />
            <v-text
              :config="{
                text: 'Сохранить',
                fontFamily: 'Calibri',
                fontSize: 18 * iconsScale,
                padding: 5 * iconsScale,
                fill: 'white',
              }"
            />
          </v-label>
        </v-layer>
      </v-stage>
      <windRose
        @rotation="handleRotation"
        :project.sync="project"
        style="position: absolute; right: 24px; bottom: 24px"
      />
    </div>
    <!-- Кнопки загрузки подложки для пустого проекта  -->
    <upload-substrate v-else @onAdd="callInputEvent" @onMapUploadClick="$bvModal.show('mapUpload')" />

    <!-- Переделанная модалка, можно взять за пример -->
    <modal-wrapper
      @onCancelClick="$bvModal.hide('pipelineConnect')"
      modalId="pipelineConnect"
      hide-footer
      :title="pipelineConnectTitle"
      dialogClass="pipeline-connect-modal"
    >
      <connectedPipeline
        @pipelineWindowClose="pipelineWindowClose()"
        :showError="showError"
        :substrate="substrate"
        :newPipeline.sync="newPipeline"
        :action.sync="action"
        :installations="installations"
        :proj_id="project.id"
        @pipelineConnect="pipelineSave($event)"
        @onCancelClick="$bvModal.hide('pipelineConnect')"
      />
    </modal-wrapper>

    <b-modal
      id="installationToMap"
      ref="installationToMap"
      hide-footer
      :title="temp.isNewRecord ? 'Добавить технологическую установку на карту' : 'Изменить'"
    >
      <center>
        <b-row class="my-1">
          <b-col sm="6">
            <label for="count">Количество установок в точке:</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="count" type="number" v-if="temp" v-model="temp.count"></b-form-input>
            <div class="text-danger" v-if="temp && temp.errors && temp.errors.count">{{ temp.errors.count[0] }}</div>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label for="hours">Время нахождения установки в точке (количество часов в сутки), ч:</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="hours" v-model="temp.hours" type="number"></b-form-input>
            <div class="text-danger" v-if="temp && temp.errors && temp.errors.hours">{{ temp.errors.hours[0] }}</div>
          </b-col>
        </b-row>
        <b-btn v-if="temp" variant="success" @click.prevent="installationToMap()"
          ><span v-if="temp.isNewRecord">Добавить</span><span v-else>Сохранить</span></b-btn
        >
      </center>
    </b-modal>

    <!-- Размещение работника на карте -->
    <modal-wrapper
      modalId="peopleToMap"
      hide-footer
      :title="temp.isNewRecord ? 'Добавить работника на карту' : 'Изменить'"
      @onCancelClick="$bvModal.hide('peopleToMap')"
    >
      <form class="modal-form">
        <custom-input
          required
          inputType="string"
          placeholder="Время нахождения работника в точке"
          labelText="Время нахождения работника в точке (количество часов в сутки), ч:"
          v-model="temp.hours"
          :errorMessage="temp && temp.errors && temp.errors.hours ? temp.errors.hours[0] : ''"
          :inputValue="temp.hours"
          name="hours"
        />
      </form>
      <div class="modal-footer-buttons">
        <main-button type="button" @click="peopleToMap()">
          <span v-if="temp.isNewRecord">Добавить</span><span v-else>Сохранить</span></main-button
        >
        <main-button color="link" type="button" @click="$bvModal.hide('peopleToMap')">Отмена</main-button>
      </div>
    </modal-wrapper>

    <!-- Добавление селитебного объекта -->
    <modal-wrapper
      @onCancelClick="$bvModal.hide('socialAdd')"
      modalId="socialAdd"
      hide-footer
      title="Добавить объект на прилегающей территории"
    >
      <socialEdit
        @onCancelClick="$bvModal.hide('socialAdd')"
        @socialEditHide="$bvModal.hide('socialAdd'); $emit('clearCalculations')"
        @socialCreated="
          socialCreated();
          $bvModal.hide('socialAdd');
        "
        :project="project"
        :social="newSocial"
        :socials.sync="residential"
        @substrateUpdate="substrateUpdate"
      />
    </modal-wrapper>

    <!-- Modal Component -->

    <modal-wrapper
      modalId="scale"
      ref="scale"
      title="Масштаб"
      dialogClass="modal-scale-wrapper"
      @onCancelClick="clickCancelScaleModal()"
      @onSaveClick="scaleSave(scale, temp.real_dist)"
    >
      <div class="modal-scale-input">
        <p>Расстояние между точками, м</p>
        <b-form-input v-model="temp.real_dist" placeholder="Введите значение"></b-form-input>
        <p class="text-danger">{{ scale.error }}</p>
      </div>
    </modal-wrapper>

    <!-- Добавление обвалования -->
    <modal-wrapper
      @onCancelClick="$bvModal.hide('dikingToMap')"
      modalId="dikingToMap"
      hide-footer
      title="Добавить обвалование на карту"
    >
      <dikingEdit
        @onCancelClick="$bvModal.hide('dikingToMap')"
        :newDiking="newDiking"
        :substrate="substrate"
        :proj_id="project.id"
        :dikings.sync="dikings"
        @hide="
          newDiking = { dots: {} };
          $bvModal.hide('dikingToMap');
        "
        @clearCalculations="$emit('clearCalculations')"
      >
      </dikingEdit>
    </modal-wrapper>

    <!-- Противопожарная стена -->
    <modal-wrapper
      @onCancelClick="handleFirewallCancelClick()"
      modalId="firewallToMap"
      hideFooter
      title="Добавить противопожарную стену"
    >
      <firewallEdit
        :newFirewall="newFirewall"
        :substrate="substrate"
        :proj_id="Number(project.id)"
        :firewalls.sync="firewalls"
        @onCancelClick="handleFirewallCancelClick()"
        @hide="handleFirewallCancelClick()"
        @clearCalculations="$emit('clearCalculations')"
      />
    </modal-wrapper>

    <modal-wrapper
      dialogClass="map-upload-wrapper"
      modalId="mapUpload"
      ref="mapUpload"
      hide-footer
      title="Использовать карту"
      @onCancelClick="$bvModal.hide('mapUpload')"
    >
      <mapUpload
        :substrate.sync="substrate"
        :proj_id="Number(project.id)"
        :city="project.city0"
        @substrateUpdate="substrateUpdate($event)"
        @onCancelClick="$bvModal.hide('mapUpload')"
      ></mapUpload>
    </modal-wrapper>

    <!-- Фильтр интенсивности теплового излучения -->
    <modal-wrapper
      dialogClass="zones-filter-wrapper"
      modalId="filter"
      @onCancelClick="$bvModal.hide('filter')"
      ref="filter"
      hide-footer
      title="Фильтр"
    >
      <zonesFilter
        @onCancelClick="$bvModal.hide('filter')"
        :getZones="getZones"
        :installations="installations"
        :pipelines="pipelines"
        :analyse.sync="analyse"
      />
    </modal-wrapper>
    <div class="toaster-wrapper">
      <custom-toast
        :key="id"
        v-for="{ content, title, id, autoHideDelay, type, noAutoHide } in toasts"
        :content="content"
        :title="title"
        :toastId="id"
        :autoHideDelay="autoHideDelay"
        :type="type"
        :noAutoHide="noAutoHide"
        @onCloseClick="handleToastCloseClick"
      />
    </div>
    <p class="rotation-angle">{{ currentRotation ? currentRotation : Math.round(project.rotate) }}°</p>
  </div>
</template>
<style>
.map-block {
  position: relative;
  background-color: rgba(122, 122, 148, 0.15);
  width: 100%;
  min-width: 980px;
  overflow: auto;
}
.toaster-wrapper {
  min-width: 930px;
  position: absolute;
  bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.map {
  overflow: hidden;
}
.disScroll {
  overflow: hidden;
}
.filterButton {
  padding: 0.3rem !important;
}

fieldset {
  border: unset !important;
}
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4) !important;
  pointer-events: none;
}
.zones-filter-wrapper {
  max-width: 900px;
}
.pipeline-connect-modal {
  max-width: 800px;
}
.map-upload-wrapper {
  max-width: 600px;
}
.modal-scale-wrapper {
  max-width: 600px;
}
.modal-scale-input {
  padding: 0 24px 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.modal-scale-input p {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 14px;
  color: var(--black-color);
  margin-bottom: 0;
}

.modal-scale-input input::placeholder {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: var(--grey-3-color);
}

.modal-scale-input input {
  border-radius: 4px;
}
.rotation-angle {
  position: absolute;
  right: 85px;
  bottom: 100px;
  pointer-events: none;
  color: var(--black-color);
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import UrlImage from "./mapEditor/UrlImage.vue";
import connectedPipeline from "./objects/connectedPipeline";
import socialEdit from "./mapEditor/socialEdit";
import nodeMenu from "./mapEditor/nodeMenu";
import pipeline from "./mapEditor/pipeline";
import dikingEdit from "./dikingEdit";
import firewallEdit from "./firewallEdit";
import { pipelines } from "./mapEditor/pipelines";
import { risks } from "./mapEditor/risks";
import { residentials } from "./mapEditor/residentials";
import { baseMethods } from "./pipelines/baseMethods";
import windRose from "./windRose";
import mapUpload from "./mapUpload";
import zonesFilter from "./zonesFilter";
import UploadSubstrate from "../../components/UploadSubstrate";
import LayersMenu from "../../components/LayersMenu";
import RiskPanel from "../../components/RiskPanel";
import RangeInputsPanel from "../../components/RangeInputsPanel";
import RiskInfo from "../../components/RiskInfo.vue";
import ModalWrapper from "../../components/modals/ModalWrapper.vue";
import MainButton from "../../components/ui/MainButton.vue";
import CustomInput from "../../components/ui/Input.vue";
import CustomToast from "../../components/ui/CustomToast.vue";

export default {
  name: "mapeditor",
  mixins: [pipelines, risks, residentials, baseMethods],
  props: {
    showErrors: Function,
    project: Object,
    substrate: {
      default: {},
    },
    action: {
      default: "do_nothing",
    },
    dikings: Array,
    analyse: Object,
    id: Number,
    temp: Object, // используется для передачи в родительский компонент данных для редактировании
    pipelines: Array,
    installations: Array,
    people: Array,
    residential: Array,
    firewalls: Array,
    solids: Array,
    oldData: Boolean,
    layers: Object,
    iconsScale: Number,
    inModulation: Boolean,
    loading: Boolean,
    tourStep: Number,
    zonesImage: String,
    legalIndRisk: Number,
    getZones: Function,
  },
  directives: {},
  components: {
    UrlImage,
    Loading,
    connectedPipeline,
    socialEdit,
    nodeMenu,
    pipeline,
    dikingEdit,
    firewallEdit,
    windRose,
    mapUpload,
    zonesFilter,
    UploadSubstrate,
    LayersMenu,
    RiskPanel,
    RangeInputsPanel,
    RiskInfo,
    ModalWrapper,
    MainButton,
    CustomInput,
    CustomToast,
  },
  created() {
    this.getPeopleImage();
  },
  mounted() {
    this.setConvaConfigParams();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    oldData() {
      if (this.hotCalc) {
        if (this.loading == false) {
          if (this.project.status != 3 || this.project.status != 1) {
            this.$nextTick(() => {
              this.$parent.energyOn();
            });
          }
        }
      } else {
        if (this.oldData == 1 && this.project.status == 2) {
          this.project.status = 0;
          this.zones = [];
          this.$http.get("projects/set-zero-status", {
            params: {
              proj_id: this.project.id,
            },
          });
          this.project.result = null;
          this.$emit("update:zonesImage", null);
        }
      }
    },
    substrate() {
      this.$http
        .get("mapeditor/get-substrate", {
          params: {
            proj_id: this.project.id,
          },
        })
        .then((response) => {
          this.$set(this, "substrateUrl", response.data);
        });
      this.$nextTick(() => {
        this.setConvaConfigParams();
      });
    },
    action() {
      this.currentRisk = {};
      if (this.action != "do_nothing" && this.action != "default") {
        this.currentRisk = {};
        this.busy = true;
      } else {
        this.busy = false;
      }
    },
  },
  computed: {
    distance() {
      return Math.sqrt(
        Math.pow(parseInt(this.scale[0].x) - this.cursor.x, 2) + Math.pow(parseInt(this.scale[0].y) - this.cursor.y, 2)
      );
    },
    maxIndRisk() {
      if (this.project.result && this.project.result.social) {
        var risk = 0;
        for (var key in this.project.result.social) {
          if (risk < this.project.result.social[key].risk) {
            risk = this.project.result.social[key].risk;
          }
        }
        return risk;
      }
      return 0;
    },
    maxIndRiskRes() {
      if (this.project.result && this.project.result.residential) {
        var risk = 0;
        for (var key in this.project.result.residential) {
          if (risk < this.project.result.residential[key].ind_risk) {
            risk = this.project.result.residential[key].ind_risk;
          }
        }
        return risk;
      }
      return 0;
    },
    maxSocialRisk() {
      if (this.project.result && this.project.result.residential) {
        var risk = 0;
        for (var key in this.project.result.residential) {
          if (risk < this.project.result.residential[key].risk) {
            risk = this.project.result.residential[key].risk;
          }
        }
        return risk;
      }
      return 0;
    },
    pipelineConnectTitle() {
      if (this.newPipeline && "obj_type" in this.newPipeline && this.newPipeline.obj_type === this.pipelineСode) {
        return "Присоединить трубопровод";
      }
      return "Присоединить гибкое соединение";
    },
    dikingsWithoutExclude() {
      if (this.dikings && this.dikings.length) {
        return this.dikings.filter((diking) => parseInt(diking.exclude) != 1 && this.layers.dikings == 1);
      }
      return this.dikings;
    },
    solidWithoutExclude() {
      if (this.solids && this.solids.length) {
        return this.solids.filter((solid) => parseInt(solid.exclude) != 1 && this.layers.solid == 1);
      }
      return this.solids;
    },
    installationWithoutExclude() {
      if (this.installations && this.installations.length) {
        return this.installations.filter(
          (installation) => parseInt(installation.exclude) != 1 && this.layers.installations == 1
        );
      }
      return this.installations;
    },
    filteredResidentialTypeOne() {
      if (this.residential && this.residential.length) {
        return this.residential.filter(
          (building) => parseInt(building.exclude) != 1 && building.type == 3 && this.layers.buildings == 1
        );
      }
      return this.residential;
    },
  },
  data() {
    return {
      hotCalc: false,
      substrateUrl: null,
      zones: [],
      risksArr: [],
      recalculated: {},
      cursor: {},
      residentials: {},
      pipelineСode: 61,

      configKonva: {
        width: 0,
        height: 0,
        draggable: true,
        scale: {
          x: 0.5,
          y: 0.5,
        },
      },
      image: null,
      scaleBy: 1.1,
      anchors: [],
      peopleImage: null,
      scale: [],
      newDiking: {},
      newSolid: null,
      newPipeline: null,
      newFirewall: null,
      newRoadDots: {},
      pipelineNode: {},
      dikingNode: {},
      solidNode: {},
      newSocial: {},
      currentRisk: {},
      busy: false,
      factors: [
        { value: 0, text: "Потенциальный риск" },
        { value: 1, text: "Интенсивность теплового излучения, кВт/м²" },
        { value: 2, text: "Избыточное давление ΔP, кПа" },
      ],
      opacity: 0.3,
      eonTimer: 0,
      menuPos: {
        x: 0,
        y: 0,
      },
      toasts: [
        {
          title: "Линейка",
          content: "Отметьте 2 точки, между которыми нужно определить расстояние",
          id: "toast-ruler-hint",
          autoHideDelay: 2000,
          type: "info-green",
        },
        {
          title: "Определить риск",
          content: "Отметьте точку, где нужно узнать значение потенциального риска",
          id: "toast-risk-hint",
          noAutoHide: true,
          type: "info-green",
        },
        {
          title: "Масштаб",
          content: "Отметьте 2 точки и укажите расстояние между ними.",
          id: "toast-scale-hint",
          autoHideDelay: 2000,
          type: "info-green",
        },
      ],
      currentRotation: null,
    };
  },
  methods: {
    handleToastCloseClick(id) {
      this.$emit("update:action", "do_nothing");
      this.$bvToast.hide(id);
    },
    handleRotation(angle) {
      this.currentRotation = Math.round(angle);
    },
    handleFirewallCancelClick() {
      this.newFirewall = { dots: {} };
      this.$bvModal.hide("firewallToMap");
    },
    handleLayerButtonClick(buttonName) {
      if (buttonName === "map-upload") {
        this.$bvModal.show("mapUpload");
      }
      if (buttonName === "set-scale") {
        this.setScale();
      }
      if (buttonName === "ruler") {
        this.ruler();
      }
      if (buttonName === "get-risk") {
        this.risk();
      }
      if (buttonName === "substrate-upload") {
        this.callInputEvent();
      }
    },
    showError(data) {
      this.showErrors(data);
    },
    callInputEvent() {
      const temporalInput = document.createElement("input");
      temporalInput.type = "file";
      temporalInput.hidden = "true";
      temporalInput.id = "substrate-upload-input";
      temporalInput.addEventListener("change", this.substrateUpload);
      temporalInput.click();
    },

    handleDropdownChange(data) {
      const [[key, value]] = Object.entries(data);
      this.layers[key] = Number(value);
    },

    handleRiskSelectChange(option) {
      this.analyse.factor = option.code;
    },

    handleFilterButtonClick() {
      this.$bvModal.show("filter");
    },

    handleOpacityChange(value) {
      this.opacity = value;
    },

    anchorsWithoutDeleted(anchors) {
      if (anchors && anchors.length) {
        return anchors.filter((anchor) => !anchor.deleted);
      }
      return anchors;
    },

    installationObjectsWithoutexclude(mapObjects) {
      if (mapObjects && mapObjects.length) {
        return mapObjects.filter((object) => parseInt(object.exclude) != 1);
      }
      return mapObjects;
    },

    handleIconScaleChange(value) {
      this.project.iconsScale = value;
      this.updateIconsScale();
    },

    updateIconsScale() {
      this.$http.get("projects/icons-scale", {
        params: {
          proj_id: this.project.id,
          scale: this.project.iconsScale,
        },
      });
    },
    substrateUpdate(substrate) {
      this.$emit("update:substrate", substrate);
      this.$refs["substrate"].hide();
    },
    socialCreated() {
      this.newRoadDots = {};
      this.$emit("update:action", "do_nothing");
      this.$emit("clearCalculations")
    },
    showPipelineNodeWindow(event) {
      if (window.event.button == 2) {
        this.pipelineNode = event.pipeline;
        this.$set(this.pipelineNode, "dot_index", event.dot_index);
        this.$set(this.pipelineNode, "tempDots", event.dots);
        this.$set(this.pipelineNode, "show", true);
      }
    },
    showDikingNodeWindow(diking, index) {
      if (window.event.button == 2) {
        this.dikingNode = diking;
        this.$set(this.dikingNode, "tempDots", diking.dots);
        this.$set(this.dikingNode, "dot_index", index);
        this.$set(this.dikingNode, "show", true);
      }
    },
    showSolidNodeWindow(solid, index) {
      if (window.event.button == 2) {
        this.solidNode = solid;
        this.$set(this.solidNode, "tempDots", solid.dots);
        this.$set(this.solidNode, "dot_index", index);
        this.$set(this.solidNode, "show", true);
      }
    },
    changeCursor(cursor) {
      var stage = this.$refs.mapLayer.getStage();
      stage.container().style.cursor = cursor;
    },
    setConvaConfigParams() {
      if (this.$refs.mapWindow) {
        const mapWindowElement = this.$refs.mapWindow;
        const { width, height } = mapWindowElement.getBoundingClientRect();

        this.$set(this.configKonva, "width", width);
        this.$set(this.configKonva, "height", height);
        this.$set(this.configKonva, "x", 100);
        this.$set(this.configKonva, "y", 100);
      }
    },
    handleResize() {
      this.setConvaConfigParams();
    },
    // Возвращает формат "0.00E-5"
    toNormal(val) {
      if (String(val).includes("e-")) {
        val = String(val);
        val = val.split("e-");
        return parseFloat(val[0]).toFixed(2) + "E-" + val[1];
      } else {
        val = String(val);
        var multiply = 0;
        for (var i in val) {
          if (val[i] == "0" || val[i] == ".") {
            multiply++;
          } else {
            break;
          }
        }
        if (multiply > 1) {
          val = val * Math.pow(10, multiply - 1);
          parseFloat(val).toFixed(2);
          return Math.floor(val * 100) / 100 + "E-" + (multiply - 1);
        } else {
          return parseInt(val).toFixed(2);
        }
      }
    },
    clickCancelScaleModal() {
      this.scale = [];
      this.$bvModal.hide("scale");
      this.$emit("update:action", "do_nothing");
    },
    clearAll() {
      this.newSolid = {};
      this.newDiking = {};
      this.newPipeline = {};
      this.newFirewall = {};
      this.scale = {};
      this.currentRisk = {};
      this.pipelineNode = {};
      this.dikingNode = {};
      this.solidNode = {};
      this.newRoadDots = {};
    },

    pipelineWindowClose() {
      this.$bvModal.hide("pipelineConnect");
    },
    pipelineFocus(index, m_index, personIndex) {
      if (!this.busy) {
        this.$emit("update:action", "do_nothing");
        this.$set(
          this.installations[index].mapObjects[m_index].pipelines[personIndex],
          "edit",
          !this.installations[index].mapObjects[m_index].pipelines[personIndex].edit
        );
      }
    },

    chunkArray(myArray, chunk_size) {
      var results = [];
      while (myArray.length) {
        results.push(myArray.splice(0, chunk_size));
      }

      return results;
    },
    mapRightClickAction() {
      alert("It`s working!");
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    peopleToMap() {
      var data = this.temp;
      if (data.isNewRecord) {
        this.$http
          .get("risk/people/to-map", {
            params: {
              proj_id: this.id,
              obj_id: this.temp.id,
              lat: data.x,
              lng: data.y,
              hours: parseFloat(data.hours),
            },
          })
          .then((response) => {
            if (!this.people[this.temp.index].mapObjects) {
              this.$set(this.people[this.temp.index], "mapObjects", []);
            }
            this.people[this.temp.index].mapObjects.push(response.data);
            this.oldData = true;
            this.$emit("update:temp", {});
            this.$bvModal.hide("peopleToMap");
          })
          .catch((e) => {
            this.$set(this.temp, "errors", e.response.data);
          });
      } else {
        this.$http
          .post("mapeditor/object-update?id=" + data.id, {
            lat: data.x,
            lng: data.y,
            hours: parseFloat(data.hours),
          })
          .then((response) => {
            this.$set(this.people[data.personIndex].mapObjects, data.index, response.data);
            this.oldData = true;
            this.$bvModal.hide("peopleToMap");
          })
          .catch((e) => {
            this.$set(this.temp, "errors", e.response.data);
          });
      }
      this.$emit("clearCalculations");
    },
    installationToMap() {
      var data = this.temp;
      if (data.isNewRecord) {
        this.$http
          .get("risk/objects/object-add", {
            params: {
              proj_id: data.proj_id,
              obj_id: data.obj_id,
              lat: data.x,
              lng: data.y,
              count: data.count,
              hours: parseFloat(data.hours),
            },
          })
          .then((response) => {
            if (!this.installations[this.temp.index].mapObjects) {
              this.$set(this.installations[this.temp.index], "mapObjects", []);
            }
            this.installations[this.temp.index].mapObjects.push(response.data);
            this.oldData = true;
            this.$emit("update:temp", {});
            this.$refs.installationToMap.hide();
          })
          .catch((e) => {
            this.$set(this.temp, "errors", e.response.data);
          });
      } else {
        this.$http
          .post("mapeditor/object-update?id=" + data.id, {
            lat: data.x,
            lng: data.y,
            count: data.count,
            hours: data.hours,
          })
          .then((response) => {
            this.$set(this.installations[data.i_index].mapObjects, data.index, response.data);
            this.oldData = true;
            this.$refs.installationToMap.hide();
          })
          .catch((e) => {
            this.$set(this.temp, "errors", e.response.data);
          });
      }
      this.$emit("clearCalculations");
    },
    drop(ev) {
      this.currentRisk = {};
      var stage = this.$refs.mapLayer.getStage();
      stage._setPointerPosition(ev);
      var pointerPosition = stage.getPointerPosition();
      var stageAttrs = stage.attrs;
      if (!stageAttrs.x) {
        stageAttrs.x = 0;
      }
      if (!stageAttrs.y) {
        stageAttrs.y = 0;
      }
      var x = (pointerPosition.x - stageAttrs.x) / stageAttrs.scaleX;
      var y = (pointerPosition.y - stageAttrs.y) / stageAttrs.scaleY;
      switch (this.temp.type) {
        case "people":
          this.$set(this.temp, "proj_id", this.id);
          this.$set(this.temp, "obj_id", this.temp.id);
          this.$set(this.temp, "x", x);
          this.$set(this.temp, "y", y);
          this.$set(this.temp, "hours", 8);
          this.$set(this.temp, "isNewRecord", true);
          this.$bvModal.show("peopleToMap");

          break;
        case "tank":
          this.$set(this.temp, "proj_id", this.id);
          this.$set(this.temp, "obj_id", this.temp.id);
          this.$set(this.temp, "x", x);
          this.$set(this.temp, "y", y);
          this.$set(this.temp, "count", 1);
          this.$set(this.temp, "hours", 24);
          this.$set(this.temp, "isNewRecord", true);
          this.$refs.installationToMap.show();
          break;
      }
    },
    toggleHtmlClass(addRemoveClass, className) {
      const el = document.getElementsByTagName("html")[0];

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    setScale() {
      this.scale = [];
      this.$bvToast.show("toast-scale-hint");
      this.$bvToast.show("scale");
      this.$emit("update:action", "scale");
    },
    ruler() {
      this.scale = [];
      this.$bvToast.show("toast-ruler-hint");
      this.$emit("update:action", "ruler");
    },
    substrateUpload(e) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      this.$http
        .post("mapeditor/substrate-upload?proj_id=" + this.id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.substrateUpdate(response.data);
        })
        .catch((e) => {
          alert(e.response.data);
        })
        .finally(() => {
          const temporalInput = document.querySelector("#substrate-upload-input");
          temporalInput.removeEventListener("change");
          temporalInput.remove();
        });
    },
    risk() {
      this.clearAll();
      if (this.oldData) {
        this.$bvToast.show("toast-risk-hint");
        return;
      }
      this.$bvToast.show("toast-risk-hint");
      this.$emit("update:action", "default");
    },
    socialNewPos(id, index) {
      var x = this.getScaledPointerPosition().x;
      var y = this.getScaledPointerPosition().y;
      this.$http
        .get("risk/socials/social-new-pos", {
          params: {
            proj_id: this.id,
            obj_id: id,
            lat: x,
            lng: y,
          },
        })
        .then(() => {
          this.$set(this.residential[index], "lat", x);
          this.$set(this.residential[index], "lng", y);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },
    objectNewPos(id, index, o_index, type) {
      //var time=parseInt(new Date().getTime())
      //if(this.eonTimer<time-100 && eon==true)
      //{
      var x = this.getScaledPointerPosition().x;
      var y = this.getScaledPointerPosition().y;
      this.$http
        .get("mapeditor/object-new-pos", {
          params: {
            proj_id: this.id,
            obj_id: id,
            lat: x,
            lng: y,
          },
        })
        .then((response) => {
          if (type == "people") {
            // JSON responses are automatically parsed.
            this.$set(this.people[index].mapObjects[o_index], "lat", x);
            this.$set(this.people[index].mapObjects[o_index], "lng", y);
            this.$set(this.people[index].mapObjects[o_index], "newPose", true);
            this.oldData = true;
          }
          if (type == "installation") {
            this.$set(this.installations[index].mapObjects[o_index], "lat", x);
            this.$set(this.installations[index].mapObjects[o_index], "lng", y);
            this.$set(this.installations[index].mapObjects[o_index], "diking_id", response.data.diking_id);
            if (response.data.Pot_rs_graf) {
              this.$set(this.installations[index], "Pot_rs_graf", response.data.Pot_rs_graf);
            } else {
              this.$set(this.installations[index].mapObjects[o_index], "newPose", true);
            }
            this.oldData = true;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },
    solidNewPos(solid) {
      var data = solid;
      data.dots = this.clearDots(data.dots);
      this.$http
        .post("risk/solids/solid-update-cords?proj_id=" + this.id + "&id=" + data.id, {
          dots: data.dots,
        })
        .then(() => {
          // JSON responses are automatically parsed.
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },
    dikingNewPos(diking) {
      if (diking.autoS == 1) {
        diking.S = this.getDikinsS(diking.dots, this.substrate.k);
      }
      var data = diking;
      data.dots = this.clearDots(data.dots);
      this.$http
        .post("risk/dikings/diking-update-cords?proj_id=" + this.id + "&id=" + data.diking_id, {
          dots: data.dots,
        })
        .then(() => {
          // JSON responses are automatically parsed.
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },
    firewallNewPos(firewall) {
      var data = firewall;
      data.dots = this.clearDots(data.dots);
      this.$http
        .post("risk/firewalls/firewall-update-cords?proj_id=" + this.id + "&id=" + data.id, {
          dots: data.dots,
        })
        .then(() => {
          // JSON responses are automatically parsed.
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => this.$emit("clearCalculations"));
    },
    socialEdit(obj_id) {
      alert(obj_id);
    },
    scaleSave(dots, real_dist) {
      if (!real_dist || real_dist < 0.1) {
        alert("Введите расстояние между точками");
        return false;
      }
      if (dots[0].x == dots[1].x && dots[0].y == dots[1].y) {
        alert("Вы отметили две одинаковые точки. Установите масштаб заново.");
        this.scale = [];
        this.$bvModal.hide("scale");
        return false;
      }
      this.$http
        .get("mapeditor/set-size", {
          params: {
            proj_id: this.id,
            A1: dots[0].x,
            A2: dots[1].x,
            B1: dots[0].y,
            B2: dots[1].y,
            real_dist: real_dist,
          },
        })
        .then((response) => {
          this.$bvModal.hide("scale");
          this.$set(this.substrate, "k", response.data);
          this.scale = [];
          this.$emit("update:action", "do_nothing");
        })
        .catch((e) => {
          this.$set(this.scale, "error", e.response.data.k[0]);
        });
    },
    mapAction() {
      switch (this.action) {
        case "scale": // if (x === 'value1')
          if (this.scale.length > 1) {
            this.scale = [];
          }
          if (this.scale.length < 1) {
            this.scale.push({ x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y });
          } else {
            this.scale.push({ x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y });
            this.$bvModal.show("scale");
          }
          break;
        case "ruler": // if (x === 'value1')
          if (this.scale.length < 1) {
            this.scale.push({ x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y });
          } else {
            this.scale = [];
          }
          break;
        case "solid": // if (x === 'value1')
          this.newSolid = { dots: {} };
          this.$set(this.newSolid, "dots", [
            { x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y },
          ]);
          this.$emit("update:action", "solidAddLine");
          break;
        case "solidAddLine": // if (x === 'value1')
          this.newSolid.dots.push({ x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y });
          break;
        case "diking": // if (x === 'value1')
          this.dikingAdd();
          break;
        case "dikingAddLine": // if (x === 'value1')
          this.dikingAddLine();
          break;
        case "firewall": // if (x === 'value1')
          this.newFirewall = { dots: {} };
          this.$set(this.newFirewall, "dots", [
            { x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y },
          ]);
          this.$emit("update:action", "firewallAddLine");
          break;
        case "firewallAddLine": // if (x === 'value1')
          this.newFirewall.dots.push({ x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y });
          break;
        case "do_nothing": // if (x === 'value1')
          break;
        case "socialAdd": // if (x === 'value1')
          this.socialAdd();
          break;
        case "newPipeline":
          this.newPipeline = { dots: {}, unconnected: true };
          this.$set(this.newPipeline, "dots", [
            { x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y },
          ]);
          this.$emit("update:action", "pipelineAddLine");
          break;
        case "pipelineConnect": // if (x === 'value1')
          this.pipelineAdd();
          break;
        case "pipelineAddLine": // if (x === 'value1')
          this.pipelineAddLine();
          break;
        case "newRoad": // if (x === 'value1')
          this.newRoadDots.push({ x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y });
          break;
        default:
          this.showRisk();
          break;
      }
    },
    dikingAddLine() {
      this.newDiking.dots.push({ x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y });
      this.buildAnchor(this.getScaledPointerPosition().x, this.getScaledPointerPosition().y);
    },
    dikingAdd() {
      this.newDiking = { dots: {} };
      this.$set(this.newDiking, "dots", [
        { x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y },
      ]);
      this.$emit("update:action", "dikingAddLine");
    },
    dikingEdit(data) {
      this.newDiking = {};
      Object.assign(this.newDiking, data.diking);
      this.newDiking.index = data.index;
      this.$bvModal.show("dikingToMap");
    },
    dikingWindow() {
      if (this.action == "dikingAddLine") {
        this.$emit("update:action", "do_nothing");
        this.$nextTick(() => {
          this.newDiking.dots.splice(-1, 1);
        });
      }
      this.$nextTick(() => {
        this.$bvModal.show("dikingToMap");
      });
    },
    solidWindow() {
      if (this.action == "solidAddLine") {
        this.$emit("update:action", "do_nothing");
        this.$nextTick(() => {
          this.newSolid.dots.splice(-1, 1);
        });
      }
      this.$emit("newSolid", JSON.parse(JSON.stringify(this.newSolid)));
      this.newSolid = {};
    },
    firewallEdit(data) {
      this.newFirewall = {};
      Object.assign(this.newFirewall, data.firewall);
      this.newFirewall.index = data.index;
      this.$bvModal.show("firewallToMap");
    },
    firewallWindow() {
      if (this.action == "firewallAddLine") {
        this.$emit("update:action", "do_nothing");
        this.$nextTick(() => {
          this.newFirewall.dots.splice(-1, 1);
        });
      }
      this.$bvModal.show("firewallToMap");
    },
    showRisk() {
      var x = this.getScaledPointerPosition().x;
      var y = this.getScaledPointerPosition().y;
      this.$http
        .post("mapeditor/show-param-val?proj_id=" + this.id + "&lat=" + x + "&lng=" + y, {
          analyse: this.analyse,
        })
        .then((response) => {
          this.currentRisk = { lat: x, lng: y, risk: response.data };
        })
        .catch((e) => {
          alert(e.response.data);
        });
    },
    getPeopleImage() {
      const image = new window.Image();
      image.src = "https://2ch.hk/old/src/10161/15257971487930.png";
      image.onload = () => {
        // set image only when it is loaded
        this.peopleImage = image;
      };
    },
    zoom(element) {
      const deltaY = element.evt.deltaY;
      var oldScale = this.configKonva.scale.x;

      var newScale = deltaY > 0 ? oldScale / this.scaleBy : oldScale * this.scaleBy;
      this.$set(this.configKonva, "scale", { x: newScale, y: newScale });

      var stage = this.$refs.mapLayer.getStage();

      var mousePointTo = {
        x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
        y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale,
      };

      var newPos = {
        x: -(mousePointTo.x - stage.getPointerPosition().x / newScale) * newScale,
        y: -(mousePointTo.y - stage.getPointerPosition().y / newScale) * newScale,
      };
      stage.position(newPos);
      stage.batchDraw();
    },
    getScaledPointerPosition(ev) {
      if (this.$refs.mapLayer) {
        var stage = this.$refs.mapLayer.getStage();
        stage.setPointersPositions(ev);
        var pointerPosition = stage.getPointerPosition();
        var stageAttrs = stage.attrs;
        if (!stageAttrs.x) {
          stageAttrs.x = 0;
        }
        if (!stageAttrs.y) {
          stageAttrs.y = 0;
        }
        var x = (pointerPosition.x - stageAttrs.x) / stageAttrs.scaleX;
        var y = (pointerPosition.y - stageAttrs.y) / stageAttrs.scaleY;
        return { x: x, y: y };
      }
    },

    getPos() {
      this.mapobjects.push({ lat: this.getScaledPointerPosition().x, lng: this.getScaledPointerPosition().y });
      this.buildAnchor(this.getScaledPointerPosition().x, this.getScaledPointerPosition().y);
    },
    buildAnchor(x, y) {
      this.anchors.push({
        x: x,
        y: y,
        strokeWidth: 2,
      });
      var keys = Object.keys(this.anchors); //получаем ключи объекта в виде массива
      var anchor = this.anchors[keys[keys.length - 1]];

      return anchor;
    },
    anchorOver() {
      document.body.style.cursor = "pointer";
    },
    anchorOut() {
      document.body.style.cursor = "default";
    },
    shapeSceneFunc(data) {
      return (context, shape) => {
        context.beginPath();
        for (var i in data.dots) {
          if (!data.dots[i].deleted) {
            context.lineTo(data.dots[i].x, data.dots[i].y);
          }
        }
        context.closePath();
        // special Konva.js method
        context.fillStrokeShape(shape);
      };
    },
    // shapePipelineFunc(data) {
    //   return (context, shape) => {
    //     context.beginPath();
    //     for (var i in data.dots) {
    //       context.lineTo(data.dots[i].x, data.dots[i].y);
    //     }
    //     context.fillStrokeShape(shape);
    //   };
    // },
    shapeSceneFuncV2(data) {
      return (context, shape) => {
        context.beginPath();
        for (var i in data.dots) {
          context.lineTo(data.dots[i].x, data.dots[i].y);
        }
        context.closePath();
        context.fillStrokeShape(shape);
      };
    },
    shapeRoadSceneFunc(roadDots) {
      return (context, shape) => {
        context.beginPath();
        for (var i in roadDots) {
          context.lineTo(roadDots[i].x, roadDots[i].y);
        }
        context.fillStrokeShape(shape);
      };
    },
    shapeBuildingSceneFunc(building) {
      return (context, shape) => {
        context.beginPath();
        for (var i in building.dots) {
          context.lineTo(building.dots[i].x, building.dots[i].y);
        }
        context.fillStrokeShape(shape);
      };
    },
  },
};
</script>
